import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Helmet } from 'react-helmet';
import { Scrollbars } from 'react-custom-scrollbars-2';

// Components
import TransitionAnimated from '../../components/utils/cssAnimations/transition/TransitionAnimated';
import InvalidOffer from '../../components/invalidOffer';
import { getTitle } from '../../helpers/utils';

class PageInvalidOffer extends Component {
  UNSAFE_componentWillMount() {
    if (!this.props.invalidOffer) {
      this.props.history.push('/');
    }
  }
  render() {
    return (
      <Scrollbars
        style={{ height: 480 }}
        className="content-page content-invalid-offer scrollbar-content">
        <Helmet title={getTitle(`Oferta inválida ${this.props.offerId || ''}`)} />
        <TransitionAnimated>
          <InvalidOffer />
        </TransitionAnimated>
      </Scrollbars>
    );
  }
}

PageInvalidOffer.propTypes = {
  invalidOffer: PropTypes.bool.isRequired,
  offerId: PropTypes.number,
  history: PropTypes.object
};

export default compose(withRouter, connect(state => ({
  invalidOffer: state.SessionReducer.invalidOffer,
  offerId: state.SessionReducer.offerId,
})))(PageInvalidOffer);
